<template>
  <div
    ref="item"
    class="carousel-item"
    :class="{ active: active }"
  >
    <slot />
  </div>
</template>

<script>
// import Hammer from 'hammerjs'

export default {
  name: 'CarouselItem',
  props: {
    index: {
      type: Number,
      default: 0
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  created () {
    // console.log('CarouselItem created')
  },
  mounted () {
    // console.log('CarouselItem mounted')
    // this.hammer()
  },
  methods: {
    // hammer () {
    //   const Tap = new Hammer.Tap()
    //   const manager = new Hammer.Manager(this.$refs.item)
    //   manager.add(Tap)
    //   manager.on('tap', (e) => {
    //     this.$emit('setActive', this.index)
    //   })
    // }
  }
}
</script>

<style lang="scss" scoped>
.carousel-item {
  width: 100%;
  height: 100%;
  cursor: pointer;

  &.active {
    opacity: 0.3;
  }
}
</style>
